import React, { useEffect, useRef, useState } from "react";
// @material-ui/core components

import { useDispatch } from "react-redux";

// core components
import Button from "components/CustomButtons/Button.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import "assets/css/styles.css";

import MenuItem from "@material-ui/core/MenuItem";
import "antd/dist/antd.css";

import { fetchAssessmentQuestionsMethods } from "reduxToolkit/features/assessmentMethod/AssessmentMethodsSlice";
import Dialog from "@material-ui/core/Dialog";

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { Form, Input, notification, Select } from "antd";
import { useTranslation } from "react-i18next";
import { updateQuestion } from "../../reduxToolkit/features/assessmentMethod/QuestionSlice";
import ErrorModal from "./ErrorModal";

const layout = {
  labelCol: {
    span: 5,
  },
  wrapperCol: {
    span: 18,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 12,
    span: 0,
  },
};

export default function EditQuestionAssessmentModal(props) {

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [data, setdata] = useState(props.selectedRowData && props.selectedRowData);

  const input1Ref = useRef(null);
  const input2Ref = useRef(null);
  const input3Ref = useRef(null);
  const input4Ref = useRef(null);

  const handleKeyDown = (event, ref) => {
    if (event.key === 'Tab') {
      ref.current.focus();
    }
  };

  const [question_id, setQuestion_id] = useState()
  const [question, setQuestion] = useState("");
  const [actual_weight, setActual_weight] = useState("");
  const [correction_mark, setCorrection_mark] = useState("");
  const [clo_id, setClo_id] = useState();
  const [assessmentMethod_id, setAssessmentMethod_id] = useState(props.assessmentMethod_id);
  const { Option } = Select;
  const [open, setOpen] = useState(false);
  const [addRequestStatus, setAddRequestStatus] = useState("idle");
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
    props.handleCloseAnchor();
  };

  const handleClose = () => {
    setOpen(false);
    props.handleCloseAnchor();
  };

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  useEffect(() => {
    setdata(props?.selectedRowData);
    setQuestion_id(props?.selectedRowData?.key);
    setQuestion(props?.selectedRowData?.question)
    setActual_weight(props?.selectedRowData?.actual_weight)
    setCorrection_mark(props?.selectedRowData?.correction_mark)
    setClo_id(props?.selectedRowData?.clo_id)
    form.setFieldsValue({
      question: props?.selectedRowData?.question,
      actual_weight: props?.selectedRowData?.actual_weight,
      correction_mark: props?.selectedRowData?.correction_mark,
      clo_id: props?.selectedRowData?.clo_id
    });
  }, [props?.selectedRowData]);

  const onFinish = async (values) => {
    setAddRequestStatus("pending");
    let updatedQuestion = { ...values, assessmentMethod: assessmentMethod_id };
    const resultAction = await dispatch(
      updateQuestion({ id: question_id, updatedQuestion })
    );
    if (updateQuestion.fulfilled.match(resultAction)) {
      // user will have a type signature of User as we passed that as the Returned parameter in createAsyncThunk
      const Question = resultAction.payload;
      dispatch(fetchAssessmentQuestionsMethods(props.course_id));
      openNotificationWithIcon("success", `Edited ${Question?.question}`);
      handleClose();
    } else {
      if (resultAction.payload) {
        // Being that we passed in ValidationErrors to rejectType in `createAsyncThunk`, those types will be available here.
        setHandledError(resultAction.payload);
        handleOpenErrorModal();
        handleClose();
      } else {
        setHandledError(resultAction.error);
        handleOpenErrorModal();
        handleClose();
      }
    }
    handleClose();
  };

  return (
    <div>
      <MenuItem onClick={handleClickOpen} disabled={props.disabled}>
        Edit Selected Question
      </MenuItem>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth="true"
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">
          <center>{t("Edit Question")}</center>
        </DialogTitle>
        <DialogContent>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <Form
                {...layout}
                form={form}
                name="control-hooks"
                onFinish={onFinish}
              >
                <Form.Item
                  name="question"
                  label="Question"
                  rules={[
                    {
                      required: true,
                      message: "Please input the question field.",
                    },
                  ]}
                >
                  <Input
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    ref={input1Ref}
                    onKeyDown={(event) => handleKeyDown(event, input2Ref)}
                  />
                </Form.Item>
                <Form.Item
                  name="actual_weight"
                  label="Actual weight"
                  rules={[
                    {
                      required: true,
                      message: "Please input the actual weight field.",
                    },
                  ]}
                >
                  <Input
                    value={actual_weight}
                    onChange={(e) => setActual_weight(e.target.value)}
                    ref={input2Ref}
                    onKeyDown={(event) => handleKeyDown(event, input3Ref)}
                  />
                </Form.Item>
                <Form.Item
                  name="correction_mark"
                  label="Correction mark"
                  rules={[
                    {
                      required: true,
                      message: "Please input the correction mark field.",
                    },
                  ]}
                >
                  <Input
                    value={correction_mark}
                    onChange={(e) => setCorrection_mark(e.target.value)}
                    ref={input3Ref}
                    onKeyDown={(event) => handleKeyDown(event, input4Ref)}
                  />
                </Form.Item>
                <Form.Item
                  name="clo_id"
                  label="Clo"
                  rules={[
                    {
                      required: true,
                      message: "Please input the Clo field.",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Clo "
                    dropdownStyle={{ zIndex: 10000 }}
                    optionFilterProp="children"
                    showSearch
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {props.course?.clos.map((clo) => (
                      <Option key={clo.id} value={clo.id}  >
                        {`${clo.code}--${clo.title}`}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item {...tailLayout}>
                  <Button
                    style={{ marginRight: "20px" }}
                    color="primary"
                    onClick={handleClose}
                  >
                    Cancel
                  </Button>
                  <Button type="primary" color="primary" htmltype="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </GridItem>
          </GridContainer>
        </DialogContent>
      </Dialog>
      <ErrorModal
        open={openErrorModal}
        handleClose={handleCloseErrorModal}
        handledError={handledError}
      />
    </div>
  );
}
